// PostSearch.js
import React, { useState } from 'react';
import Search from './Search';
import PostListSearch from './PostListSearch';

function PostSearch() {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (query) => {
    // Update the search query
    setSearchQuery(query);
  };

  return (
    <div className="PostSearch">
      <Search onSearch={handleSearch} />
      <PostListSearch searchQuery={searchQuery} />
    </div>
  );
}

export default PostSearch;
